import { render, staticRenderFns } from "./PluginWrapper.vue?vue&type=template&id=177a7c88&functional=true&"
import script from "./PluginWrapper.vue?vue&type=script&lang=js&"
export * from "./PluginWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports